import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { Loader2, LinkIcon } from "lucide-react";
import { BrandMark } from "@/components/BrandMark";
import { useAuth } from "@/context/AuthContext";
import { api } from "@/lib/api";
import { JoinHeader, JoinForm } from "@/components/crew/JoinForm";
import { JoinAccept, JoinDone } from "@/components/crew/JoinSteps";

const Shell = ({ children }) => (
  <div className="min-h-screen bg-secondary/40 flex flex-col items-center px-4 py-8" data-testid="join-page">
    <div className="w-full max-w-md rounded-3xl bg-card border border-border shadow-xl overflow-hidden">{children}</div>
    <div className="mt-6 opacity-70"><BrandMark size="sm" /></div>
  </div>
);

// Public page behind a crew join link / QR code.
export default function JoinCrew() {
  const { code } = useParams();
  const { user, loading } = useAuth();
  const [info, setInfo] = useState(null);
  const [err, setErr] = useState("");
  const [doneEmail, setDoneEmail] = useState("");
  useEffect(() => {
    document.title = "Join the crew · Cross Jobs";
    api.joinInfo(code).then(setInfo).catch((e) => setErr(e?.response?.data?.detail || "This join link isn't valid."));
  }, [code]);

  if (err) {
    return <Shell><div className="p-8 text-center space-y-3" data-testid="join-invalid"><LinkIcon className="w-10 h-10 text-muted-foreground mx-auto" /><p className="font-semibold">{err}</p></div></Shell>;
  }
  if (!info || loading) return <Shell><div className="flex justify-center py-24"><Loader2 className="w-7 h-7 animate-spin text-primary" /></div></Shell>;
  return (
    <Shell>
      <JoinHeader info={info} />
      <div className="p-6">
        {doneEmail ? <JoinDone info={info} email={doneEmail} />
          : user ? <JoinAccept code={code} info={info} onDone={setDoneEmail} />
          : <JoinForm code={code} onDone={setDoneEmail} />}
      </div>
    </Shell>
  );
}
